import { useEffect, useState } from "react";

import { useRecoilValue } from "recoil";
import { TextM, TextMS } from "../../common/text";
import { registerAtom } from "../../recoil/atoms";
import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  useReSendSms,
  useSendSms,
  useValidateSms,
} from "./RegisterValidatePhone.helpers";
import {
  NextButton,
  NextButtonText,
  Header,
  ContentContainer,
  Resend,
  RegisterWrapper,
  Input,
} from "./RegisterValidatePhone.styles";
import { useReloadWarning } from "../../common/hooks";

import { TailSpin } from "react-loader-spinner";

const RegisterValidatePhone = () => {
  const { phone, smsMessage } = useRecoilValue(registerAtom);
  const [isSmsSending, setIsSmsSending] = useState(false);
  const [input, setInput] = useState(""); // 사용자의 인증번호 입력
  const [isValidInput, setIsValidInput] = useState(false);

  const { mutate: sendSms } = useSendSms(); // sms 발송 훅
  const { mutate: reSendSms } = useReSendSms(setIsSmsSending); // sms 발송 훅
  const { mutate: validateSms } = useValidateSms(); // sms 인증 훅

  const onClickValidatePhone = () => {
    const data = {
      phone,
      authenticationNumber: input,
      isRegister: true,
    };
    validateSms(data);
  };

  const onClickResend = () => {
    setIsSmsSending(true);
    reSendSms(phone);
  };

  useEffect(() => {
    if (phone) {
      sendSms({ phone, isRegister: true });
    }
  }, []);

  const onInputChange = (currentInput) => {
    setInput(currentInput);
    if (currentInput.length === 6) {
      setIsValidInput(true); // 6자리일때
    } else {
      setIsValidInput(false);
    }
  };

  useReloadWarning();

  return (
    <DetailPageLayout headerText={"휴대폰 인증"}>
      <ContentContainer>
        <Header>
          <TextMS>
            {phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}
          </TextMS>
          <TextM>전송된 인증번호를 입력해주세요</TextM>
        </Header>
        <RegisterWrapper>
          <Input
            value={input}
            onChange={onInputChange}
            numInputs={6}
            isInputNum
            inputStyle={{
              border: "0",
            }}
            focusStyle={{
              border: "0",
              outline: "none",
            }}
          />
          <TextMS color="#f44b59">{smsMessage}</TextMS>

          <TextM>인증번호를 받지 못하셨나요?</TextM>
          {isSmsSending ? (
            <TailSpin height={"35px"} width={"35px"} color={"grey"}></TailSpin>
          ) : (
            <Resend onClick={onClickResend}>재전송</Resend>
          )}
        </RegisterWrapper>

        <NextButton onClick={onClickValidatePhone} isValidInput={isValidInput}>
          <NextButtonText isValidInput={isValidInput}>다음</NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterValidatePhone;

/* <TextM>
{parseInt(time / 60)} : {getSeconds(time)}
</TextM> */

// const [time, setTime] = useState(300);

// const getSeconds = (time) => {
//   const seconds = Number(time % 60);
//   if (seconds < 10) {
//     return "0" + String(seconds);
//   } else {
//     return String(seconds);
//   }
// };

// useEffect(() => {
//   const timer = setInterval(() => {
//     setTime((prev) => prev - 1);
//   }, 1000);
//   return () => clearInterval(timer);
// }, [time]);

// if (time < 0) {
//   alert("인증시간이 초과되었습니다. 초기 화면으로 이동합니다.");
//   window.location.href = "/login";
// }
